module.exports = __webpack_public_path__ + "assets/img/icon10.6372920a.png";